"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconServiceByIndustry = function IconServiceByIndustry(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M31.216 6.784a2.75 2.75 0 0 0-2.185-.795l-.089.01H24v2h5l.256-.02a.75.75 0 0 1 .756.866L30 9l-.005.124c-.045.6-.438.876-1.295.876H14.057l-.088-.01a2.75 2.75 0 0 0-2.957 3.165l1.976-.31-.009-.102a.75.75 0 0 1 .866-.755L14 12h14.7l.198-.004c1.768-.07 3.01-1.094 3.097-2.803l.003-.125.013-.1a2.75 2.75 0 0 0-.795-2.184M18 15v9h-2v-4H9v19H7V15zm-9 2v2h7v-2zm29 5H26v5H12v16h26.665q1.201-.93 2.276-2H14V29h27v8h2V27h-5zm-2 5v-3h-8v3zm-3 6v4h-1v-4zm-5 4v-4h-1v4zm-5-4v4h-1v-4zm15 4v-4h-1v4zm-20-4v4h-1v-4z",
    clipRule: "evenodd"
  })));
};

export { IconServiceByIndustry, IconServiceByIndustry as default };
